/* a-sk: zachowania sekcji sklejki acne (szablon product.acne-sklejka, sekcje hm-sk-*), 29.10.2026.
   Strona statyczna: bez animacji przewijania, bez liczników i paralaksy. DOM zmieniany tylko przez textContent, klasy,
   atrybuty i cloneNode (bez wstawiania surowego HTML).
   1) [data-sk-cd]     odliczanie do data-end; po upływie pokazuje tekst zamknięcia (hidden).
   2) [data-sk-rev]    karuzela opinii: strzałki, kropki, stan kropek przy przewijaniu.
   3) [data-sk-offer]  finalny offer BEZ własnej logiki koszyka: kopiuje (cloneNode) przełącznik Subscribe/One Time i karty
      pakietów z głównego bloku zakupu hm-ef-buy; klik w kartę offeru = klik w ten sam plan w hero, klik w zakładkę = klik
      w zakładkę hero; stan wraca ze zdarzenia hm:plan. Przycisk offeru to .js-buy (hm-base.js klika główny [data-hm-buy],
      etykietę .lbl ustawia hm-ef-buy.js). Kopie nie mają name="hm_plan" ani data-* planu, więc formularz hero ich nie widzi. */
(function () {
  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* 1 · odliczanie */
  function cd(root) {
    if (root.dataset.skInit) return; root.dataset.skInit = '1';
    var end = Date.parse(root.dataset.end || ''), live = root.querySelector('[data-sk-cd-live]'), done = root.querySelector('[data-sk-cd-done]');
    var u = [].slice.call(root.querySelectorAll('[data-cd]')), t = null;
    if (isNaN(end)) return;
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { if (live) live.hidden = true; if (done) done.hidden = false; if (t) clearInterval(t); return; }
      var s = Math.floor(ms / 1000), v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      u.forEach(function (el) { var x = pad(v[el.getAttribute('data-cd')]); if (el.textContent !== x) el.textContent = x; });
    }
    tick(); t = setInterval(tick, 1000);
  }

  /* 2 · karuzela opinii */
  function rev(root) {
    if (root.dataset.skInit) return; root.dataset.skInit = '1';
    var tr = root.querySelector('[data-rev-track]'); if (!tr) return;
    var cards = [].slice.call(tr.children), dots = [].slice.call(root.querySelectorAll('[data-rev-dots] button'));
    var pv = root.querySelector('[data-rev-prev]'), nx = root.querySelector('[data-rev-next]'), bh = RM ? 'auto' : 'smooth';
    function stepW() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : tr.clientWidth; }
    function upd() {
      var w = stepW() || 1, i = Math.round(tr.scrollLeft / w), max = tr.scrollWidth - tr.clientWidth;
      if (tr.scrollLeft >= max - 4) i = cards.length - 1;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (pv) pv.disabled = tr.scrollLeft < 4;
      if (nx) nx.disabled = tr.scrollLeft >= max - 4;
    }
    if (pv) pv.addEventListener('click', function () { tr.scrollBy({ left: -stepW(), behavior: bh }); });
    if (nx) nx.addEventListener('click', function () { tr.scrollBy({ left: stepW(), behavior: bh }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { tr.scrollTo({ left: k * stepW(), behavior: bh }); }); });
    var q = false;
    tr.addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(function () { q = false; upd(); }); } }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  /* 3 · finalny offer sterujący blokiem zakupu hero */
  function offer(root) {
    if (root.dataset.skInit) return;
    var hero = document.querySelector('[data-hm-buy-section]'), box = root.querySelector('[data-sk-offer-cards]');
    if (!hero || !box) return;
    var form = hero.querySelector('form.buy-form'); if (!form) return;
    var heroCards = [].slice.call(form.querySelectorAll('.plan.bnd'));
    if (!heroCards.length) return;
    root.dataset.skInit = '1';
    var heroTabs = [].slice.call(form.querySelectorAll('[data-ptab]'));
    var grp = 'sk-offer-' + Math.random().toString(36).slice(2, 8);
    while (box.firstChild) box.removeChild(box.firstChild);
    function clean(el) { // kopia bez atrybutów edytora i identyfikatorów (nie dubluje id ani bloku w edytorze)
      [el].concat([].slice.call(el.querySelectorAll('*'))).forEach(function (n) {
        n.removeAttribute('id'); n.removeAttribute('data-shopify-editor-block');
        n.removeAttribute('aria-controls'); n.removeAttribute('aria-describedby');
      });
      return el;
    }
    var pairs = [], tabPairs = [];
    var tabsWrap = form.querySelector('.ptabs');
    if (tabsWrap) {
      var tc = clean(tabsWrap.cloneNode(true));
      [].slice.call(tc.querySelectorAll('[data-ptab]')).forEach(function (b) {
        var h = heroTabs.filter(function (x) { return x.dataset.ptab === b.dataset.ptab; })[0];
        b.setAttribute('data-sk-ptab', b.dataset.ptab); b.removeAttribute('data-ptab');
        tabPairs.push({ c: b, h: h });
        b.addEventListener('click', function () { if (h && !h.classList.contains('on')) keep(b, function () { h.click(); }); });
      });
      box.appendChild(tc);
      var sn = root.querySelector('[data-sk-subnote]');
      if (sn) box.appendChild(sn); // linia „Free shipping on every delivery…” pod przełącznikiem (tylko Subscribe & Save)
      var th = form.querySelector('.ptabs-h');
      if (th) box.appendChild(clean(th.cloneNode(true)));
    }
    heroCards.forEach(function (hc) {
      var hi = hc.querySelector('input[name=hm_plan]'); if (!hi) return;
      var c = clean(hc.cloneNode(true)), ci = c.querySelector('input');
      [].slice.call(ci.attributes).forEach(function (a) { if (a.name.indexOf('data-') === 0) ci.removeAttribute(a.name); });
      ci.removeAttribute('value'); ci.removeAttribute('checked'); ci.setAttribute('name', grp);
      c.setAttribute('data-sk-for', hi.value);
      ci.addEventListener('change', function () { if (ci.checked && !hi.checked) keep(c, function () { hi.click(); }); });
      pairs.push({ c: c, ci: ci, h: hc, hi: hi });
      box.appendChild(c);
    });
    var heroPay = hero.querySelector('.payt.pay-b'), heroAmt = hero.querySelector('[data-pay-amt]'), amt = null;
    if (heroPay) { // „Or 4 interest-free payments of … with Shop Pay” — kopia, kwota z hero
      var pc = clean(heroPay.cloneNode(true)); amt = pc.querySelector('[data-pay-amt]');
      if (amt) { amt.removeAttribute('data-pay-amt'); amt.setAttribute('data-sk-pay', ''); }
      box.appendChild(pc);
    }
    var subnote = root.querySelector('[data-sk-subnote]');
    // klik w offerze zmienia wysokość hero (rozwinięte karty, linia renew) — offer zostaje w tym samym miejscu ekranu
    function keep(el, act) {
      var t0 = el.getBoundingClientRect().top;
      act();
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        var d = el.getBoundingClientRect().top - t0;
        if (Math.abs(d) > 1) window.scrollBy({ top: d, left: 0, behavior: 'instant' });
      }); });
    }
    function sync() {
      pairs.forEach(function (p) {
        p.c.hidden = p.h.hidden;
        p.c.classList.toggle('on', p.h.classList.contains('on'));
        p.ci.checked = p.hi.checked;
      });
      tabPairs.forEach(function (p) {
        if (!p.h) return;
        var on = p.h.classList.contains('on');
        p.c.classList.toggle('on', on); p.c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var subOn = tabPairs.some(function (p) { return p.h && p.h.dataset.ptab === 'sub' && p.h.classList.contains('on'); });
      if (subnote) subnote.hidden = !subOn;
      if (amt && heroAmt) amt.textContent = heroAmt.textContent;
    }
    sync();
    document.addEventListener('hm:plan', function () { requestAnimationFrame(sync); });
    window.addEventListener('pageshow', function () { requestAnimationFrame(sync); });
  }

  function all() {
    document.querySelectorAll('[data-sk-cd]').forEach(cd);
    document.querySelectorAll('[data-sk-rev]').forEach(rev);
    document.querySelectorAll('[data-sk-offer]').forEach(offer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
